import { get } from '@classic/Foundation/Services/ApiService'

export const getCountryEntitlements = () =>
  get<{ data: { isCountryEntitled: boolean } }>({ url: '/api/entitlements/GetCountryEntitlements' })
